import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-mauve disabled:pointer-events-none disabled:opacity-40",
  {
    variants: {
      variant: {
        default: "bg-mauve text-crust hover:bg-mauve/80",
        destructive: "bg-red text-crust hover:bg-red/80",
        outline: "border border-surface1 text-subtext0 hover:bg-surface0 hover:text-subtext1",
        secondary: "bg-surface0 text-subtext0 hover:bg-surface1 hover:text-subtext1",
        ghost: "text-overlay1 hover:bg-surface0 hover:text-subtext0",
        link: "text-blue underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
